import React from 'react';
import EditDish from '../EditDish/EditDish';
import { Modals } from '../../utils/constants';

import { Modal, Card } from 'wix-style-react';

export default class EditDishModal extends React.PureComponent {
  onSubmit = () => {
    const { cartUpsert, orderItem, cartIndex, hideModal } = this.props;

    cartUpsert({ orderItem, cartIndex });
    hideModal({ modal: Modals.EDIT_DISH });
  };

  onCloseClick = () => {
    this.props.hideModal({ modal: Modals.EDIT_DISH });
  };

  render() {
    const { isOpen, ...rest } = this.props;
    return (
      <Modal isOpen={isOpen} onRequestClose={this.onCloseClick} shouldCloseOnOverlayClick contentLabel="">
        <Card>{isOpen && <EditDish {...rest} onSubmit={this.onSubmit} onCloseClick={this.onCloseClick} />}</Card>
      </Modal>
    );
  }
}
